<h2 mat-dialog-title>Formu Aktif Et</h2>
<mat-dialog-content class="mat-typography">
  Formu aktif etmek istediğinize emin misiniz?
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
</mat-dialog-content>
<mat-dialog-actions [align]="'end'">
  <button mat-button mat-dialog-close>Hayır</button>
  <button mat-button (click)="continue()">Evet</button>
</mat-dialog-actions>
